export class GoogleStreetAddressModel {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;

  constructor(addressComponents: google.maps.GeocoderAddressComponent[]) {
    const typeComponentMap: Record<string, google.maps.GeocoderAddressComponent> = addressComponents.reduce((map, comp) => {
      comp.types.forEach(type => {
        map[type] = comp;
      });
      return map;
    }, {});

    const street = typeComponentMap.street_number?.short_name || '';
    const route = typeComponentMap.route?.short_name || '';
    const addressDelimiter = street && route ? ' ' : '';
    const address1 = `${street}${addressDelimiter}${route}`;

    this.address1 = address1;
    this.address2 = typeComponentMap.subpremise?.short_name;
    this.city = typeComponentMap.locality?.long_name || typeComponentMap.sublocality?.long_name;
    this.state = typeComponentMap.administrative_area_level_1?.short_name;
    this.zip = typeComponentMap.postal_code?.short_name;
  }
}
